// automatically generated by the FlatBuffers compiler, do not modify

export enum Visualization{
  BasicColor = 0,
  VertexColor = 1,
  PhotoMapping = 2
}

